import { ref } from 'vue'

const isCollapsed = ref(false)
const isMobileOpen = ref(false)

export function useSidebar() {
  const toggleSidebar = () => {
    isCollapsed.value = !isCollapsed.value
    localStorage.setItem('admin-sidebar-collapsed', isCollapsed.value.toString())
  }

  const openMobileSidebar = () => {
    isMobileOpen.value = true
  }

  const closeMobileSidebar = () => {
    isMobileOpen.value = false
  }

  const toggleMobileSidebar = () => {
    isMobileOpen.value = !isMobileOpen.value
  }

  // Initialize from localStorage
  const stored = localStorage.getItem('admin-sidebar-collapsed')
  if (stored !== null) {
    isCollapsed.value = stored === 'true'
  }

  return {
    isCollapsed,
    isMobileOpen,
    toggleSidebar,
    openMobileSidebar,
    closeMobileSidebar,
    toggleMobileSidebar
  }
}
